import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useDeleteFilter = function useDeleteFilter() {
  return useMutation(function (id) {
    return servicesUtils.postService("/profile/filters/".concat(id, "/delete/"));
  });
};
export default useDeleteFilter;